export default __webpack_public_path__ + "static/media/Mock Creative.2c62c88a.png";